// Estado y formato de insumos, compartidos por Inventario y Movimientos.
export const num = (v: any) => parseFloat(v || 0) || 0;
export const cant = (v: any) => num(v).toLocaleString('es-MX', { maximumFractionDigits: 3 });
export const fechaCorta = (iso: string) =>
  new Date(iso).toLocaleString('es-MX', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

export type EstadoInsumo = { label: string; bg: string; fg: string };

// Sobre lo disponible (stock − apartado por comandas abiertas), igual que la alerta del servidor.
export function estadoInsumo(i: any): EstadoInsumo {
  if (i.controla_stock === false) return { label: 'No se inventaría', bg: 'var(--well)', fg: 'var(--muted)' };
  const disp = num(i.stock_disponible ?? i.stock_actual);
  if (disp <= 0) return { label: 'Agotado', bg: 'var(--danger-bg)', fg: 'var(--danger)' };
  if (disp <= num(i.stock_minimo)) return { label: 'Stock bajo', bg: 'var(--warn-bg)', fg: 'var(--warn)' };
  return { label: 'Normal', bg: 'var(--ok-bg)', fg: 'var(--ok)' };
}

export const TIPO_MOV: Record<string, string> = {
  entrada: 'Entrada', ajuste: 'Salida', merma: 'Merma', venta: 'Venta',
  requisicion: 'Requisición', consumo_empleado: 'Comida empleados',
};

// Mismos motivos que la app móvil, para que el historial hable un solo idioma.
export const MOTIVOS = {
  entrada: ['Compra a proveedor', 'Devolución de cocina', 'Sobró de producción', 'Corrección de conteo'],
  salida: ['Se usó en cocina', 'Se echó a perder', 'Traspaso / préstamo', 'Corrección de conteo'],
  merma: ['Caducado', 'Se echó a perder', 'Se cayó / derramó', 'Error de preparación'],
};
